export default __webpack_public_path__ + "static/media/logo-whitelabel.9b021dc8.png";